"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
/** @jsxFrag React.Fragment */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const react_redux_1 = require("react-redux");
const b_1 = __importDefault(require("b_"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const actions_1 = require("src/redux/actions");
const tumbler_1 = __importDefault(require("../tumbler"));
const mobile_header_1 = __importDefault(require("./mobile-header"));
const scroll_panel_labels_1 = __importDefault(require("./scroll-panel-labels"));
const header_styles_1 = __importDefault(require("./header.styles"));
const b = b_1.default.with('header');
// eslint-disable-next-line max-statements
function Header({ pages, displayHiddenQuestions, setDisplayHiddenQuestions, pagesDisplayed }) {
    const i18n = (0, i18n_1.default)(['labels']);
    const containerRef = (0, react_2.useRef)(null);
    const wrapperRef = (0, react_2.useRef)(null);
    const tumblerRef = (0, react_2.useRef)(null);
    const [tumblerWidth, setTumblerWidth] = (0, react_2.useState)(0);
    const [isScrollable, setIsScrollable] = (0, react_2.useState)(false);
    const pagesToDisplay = new Set(pagesDisplayed.map(page => page.id));
    const labelRefs = (0, react_2.useRef)({});
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_2.useLayoutEffect)(() => {
        if (tumblerRef) {
            setTumblerWidth(tumblerRef.current.clientWidth);
        }
    }, [tumblerRef]);
    (0, react_2.useEffect)(() => {
        if (containerRef && wrapperRef) {
            setIsScrollable(containerRef.current.scrollWidth > wrapperRef.current.clientWidth);
        }
    });
    (0, react_2.useEffect)(() => {
        var _a, _b;
        if (!containerRef)
            return;
        const pageLabel = containerRef.current.querySelector(`#page${(_a = pages === null || pages === void 0 ? void 0 : pages.list[pages.currentPage]) === null || _a === void 0 ? void 0 : _a.id}`);
        if (!pageLabel)
            return;
        const currentIdx = pagesDisplayed.findIndex(page => pages.list[pages.currentPage].id === page.id);
        (_b = labelRefs.current[currentIdx]) === null || _b === void 0 ? void 0 : _b.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
        });
    }, [pages.currentPage, containerRef, wrapperRef, isScrollable]);
    const handleClick = (direction = 1) => {
        containerRef.current.scrollTo({
            left: (containerRef.current.scrollLeft += 50 * direction),
            behavior: 'smooth'
        });
    };
    const handleTumbleChange = () => {
        setDisplayHiddenQuestions(prev => !prev);
        dispatch((0, actions_1.addNotification)(displayHiddenQuestions
            ? i18n(['hiddenQuestionsDeactivated'])
            : i18n(['hiddenQuestionsActivated'])));
    };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b() }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('navigation') }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: (0, header_styles_1.default)(tumblerWidth) }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('mobile-wrapper') }, { children: (0, jsx_runtime_1.jsx)(mobile_header_1.default, { pages: pages, tumblerRef: tumblerRef, handleTumbleChange: handleTumbleChange, displayHiddenQuestions: displayHiddenQuestions, pagesToDisplay: pagesToDisplay }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('wrapper') }, { children: [(0, jsx_runtime_1.jsx)(tumbler_1.default, { label: i18n(['showHiddenQuestions']), checked: displayHiddenQuestions, onChange: handleTumbleChange, className: b('tumbler'), direction: 'ltr', ref: tumblerRef }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('label-container'), ref: wrapperRef, dir: 'ltr' }, { children: [isScrollable && ((0, jsx_runtime_1.jsx)(IconButton, { onClick: () => handleClick(-1), imageSrc: 'https://yastatic.net/s3/distribution/pythia/poll/_/arrow-left.svg', imageAlt: 'arrow left', className: b('icon-left') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('scrollpanel-wrapper') }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('scrollpanel'), ref: containerRef }, { children: (0, jsx_runtime_1.jsx)(scroll_panel_labels_1.default, { pages: pages, pagesToDisplay: pagesToDisplay, labelRefs: labelRefs }) })) })), isScrollable && ((0, jsx_runtime_1.jsx)(IconButton, { onClick: () => handleClick(), imageSrc: 'https://yastatic.net/s3/distribution/pythia/poll/_/arrow-right.svg', imageAlt: 'arrow right', className: b('icon-right') }))] }))] }))] })) })));
}
exports.default = Header;
function IconButton({ onClick, imageSrc, imageAlt, className }) {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `${b('icon')} ${className}`, onClick: onClick }, { children: (0, jsx_runtime_1.jsx)("img", { src: imageSrc, alt: imageAlt }) })));
}
